import React from 'react';
import DocumentHead from 'components/DocumentHead';

import useScrollToTop from 'hooks/useScrollToTop';
import AthleteForm from 'components/signUp/AthleteForm';

const AthleteSignUp = () => {
  useScrollToTop();

  return (
    <>
      <DocumentHead>
        <title>Athlete | GigSocial</title>
      </DocumentHead>

      <AthleteForm />
    </>
  );
};

export default AthleteSignUp;
